/**
 * kw-newsletter.js — three opt-in surfaces:
 * 1. Injects a footer inline newsletter block above the site footer
 * 2. Exit-intent modal (desktop, fires once per 30 days)
 * 3. Favorites-page CTA banner ("email me if any of these go on sale")
 * All submit to Shopify's built-in customer.create form (subscribers land in
 * Shopify Customers → swap to Klaviyo later without changing the UI).
 */
(function () {
  var LS_MODAL = 'kw-nl-modal-seen';
  var LS_OK = 'kw-nl-ok';
  var DAYS = 30;

  function csrfToken() {
    var m = document.querySelector('meta[name="csrf-token"]');
    return m ? m.getAttribute('content') : '';
  }

  function submit(form, cb) {
    var email = form.querySelector('input[type="email"]').value.trim();
    var msg = form.parentElement.querySelector('.kw-nl-msg');
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
      msg.textContent = 'Please enter a valid email.';
      msg.classList.remove('kw-nl-msg--ok');
      return;
    }
    msg.textContent = 'Sending…';
    msg.classList.remove('kw-nl-msg--ok');
    // Shopify's customer create endpoint
    var fd = new FormData();
    fd.append('form_type', 'customer');
    fd.append('utf8', '✓');
    fd.append('contact[tags]', 'newsletter,kindred-wooden-site');
    fd.append('contact[email]', email);
    fetch('/contact#contact_form', { method: 'POST', body: fd, credentials: 'same-origin' })
      .then(function () {
        localStorage.setItem(LS_OK, '1');
        msg.textContent = 'You\'re on the list. Watch your inbox.';
        msg.classList.add('kw-nl-msg--ok');
        form.reset();
        if (typeof cb === 'function') cb();
        // dispatch event so analytics can react
        document.dispatchEvent(new CustomEvent('kw:newsletter-signup', { detail: { email: email } }));
      })
      .catch(function () {
        msg.textContent = 'Something went wrong. Try again in a moment.';
      });
  }

  // ------------------------------------------------------------
  // 1) Footer inline
  // ------------------------------------------------------------
  function injectFooter() {
    if (document.getElementById('kw-nl-footer')) return;
    var footer = document.querySelector('footer');
    if (!footer) return;
    var wrap = document.createElement('section');
    wrap.id = 'kw-nl-footer';
    wrap.className = 'kw-nl-footer';
    wrap.innerHTML =
      '<div class="kw-nl-footer__wrap">' +
      '  <div class="kw-nl-footer__eyebrow">Kindred Wooden Journal</div>' +
      '  <h2 class="kw-nl-footer__h">Slow letters<br>from the workshop.</h2>' +
      '  <p class="kw-nl-footer__sub">One email a month. New pieces, essays on craft, first look at limited runs. Unsubscribe anytime.</p>' +
      '  <form class="kw-nl-form" onsubmit="event.preventDefault(); return false;">' +
      '    <input type="email" placeholder="your@email.com" autocomplete="email" required>' +
      '    <button type="submit">Subscribe</button>' +
      '  </form>' +
      '  <div class="kw-nl-msg" role="status"></div>' +
      '</div>';
    footer.parentNode.insertBefore(wrap, footer);
    var form = wrap.querySelector('form');
    form.addEventListener('submit', function (e) { e.preventDefault(); submit(form); });
  }

  // ------------------------------------------------------------
  // 2) Exit-intent modal
  // ------------------------------------------------------------
  function shouldShowModal() {
    if (localStorage.getItem(LS_OK)) return false;
    var seen = parseInt(localStorage.getItem(LS_MODAL) || '0', 10);
    if (Date.now() - seen < DAYS * 24 * 3600 * 1000) return false;
    // don't show on cart/checkout/favorites
    if (/\/cart|\/checkout|\/pages\/favorites/.test(window.location.pathname)) return false;
    // no touch devices — exit-intent unreliable
    if ('ontouchstart' in window && navigator.maxTouchPoints > 0) return false;
    return true;
  }

  function injectExitModal() {
    if (document.getElementById('kw-exit-modal')) return;
    var m = document.createElement('div');
    m.id = 'kw-exit-modal';
    m.setAttribute('role', 'dialog');
    m.setAttribute('aria-hidden', 'true');
    m.innerHTML =
      '<div class="kw-exit-modal__box">' +
      '  <button class="kw-exit-modal__close" aria-label="Close">×</button>' +
      '  <div class="kw-exit-modal__eyebrow">Before you go</div>' +
      '  <h2 class="kw-exit-modal__h">A welcome gift.</h2>' +
      '  <p class="kw-exit-modal__sub">10% off your first sculpture, plus one honest email a month from the workshop.</p>' +
      '  <div class="kw-exit-modal__code">KINDRED10</div>' +
      '  <form class="kw-nl-form" onsubmit="event.preventDefault();">' +
      '    <input type="email" placeholder="your@email.com" required>' +
      '    <button type="submit">Send me the code</button>' +
      '  </form>' +
      '  <div class="kw-nl-msg" role="status"></div>' +
      '</div>';
    document.body.appendChild(m);
    var form = m.querySelector('form');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      submit(form, function () {
        setTimeout(function () { m.classList.remove('kw-show'); }, 2000);
      });
    });
    m.querySelector('.kw-exit-modal__close').addEventListener('click', function () {
      m.classList.remove('kw-show');
    });
    m.addEventListener('click', function (e) {
      if (e.target === m) m.classList.remove('kw-show');
    });
  }

  function bindExitIntent() {
    if (!shouldShowModal()) return;
    // Fire once mouse leaves top edge of viewport
    var fired = false;
    document.addEventListener('mouseleave', function (e) {
      if (fired) return;
      if (e.clientY > 0) return;
      fired = true;
      localStorage.setItem(LS_MODAL, String(Date.now()));
      document.getElementById('kw-exit-modal').classList.add('kw-show');
    });
    // Fallback: after 60s on desktop show anyway
    setTimeout(function () {
      if (fired) return;
      if (!shouldShowModal()) return;
      fired = true;
      localStorage.setItem(LS_MODAL, String(Date.now()));
      document.getElementById('kw-exit-modal').classList.add('kw-show');
    }, 60000);
  }

  // ------------------------------------------------------------
  // 3) Favorites-page CTA
  // ------------------------------------------------------------
  function injectFavoritesCta() {
    if (window.location.pathname.replace(/\/$/, '') !== '/pages/favorites') return;
    if (document.getElementById('kw-fav-cta')) return;
    var root = document.getElementById('kw-favs-root');
    if (!root) return setTimeout(injectFavoritesCta, 400);
    var cta = document.createElement('section');
    cta.id = 'kw-fav-cta';
    cta.style.cssText = 'max-width:820px;margin:0 auto 32px;padding:24px 28px;background:#f4efe4;border-radius:8px;display:flex;gap:20px;align-items:center;flex-wrap:wrap;';
    cta.innerHTML =
      '<div style="flex:1;min-width:220px;">' +
      '  <div style="font-size:0.72rem;letter-spacing:0.24em;text-transform:uppercase;color:#8A7860;margin-bottom:6px;">Save for later</div>' +
      '  <div style="font-family:Georgia,serif;font-size:1.15rem;color:#1c1c1c;">Email me if any of my saved pieces go on sale.</div>' +
      '</div>' +
      '<form class="kw-nl-form" style="max-width:340px;flex:1;">' +
      '  <input type="email" placeholder="your@email.com" required style="background:#fff;color:#1c1c1c;border-color:#d5d0c2;">' +
      '  <button type="submit" style="background:#1c1c1c;color:#fff;">Notify me</button>' +
      '</form>' +
      '<div class="kw-nl-msg" role="status" style="flex-basis:100%;text-align:right;color:#8A7860;"></div>';
    root.insertBefore(cta, root.firstChild);
    var form = cta.querySelector('form');
    form.addEventListener('submit', function (e) { e.preventDefault(); submit(form); });
  }

  function init() {
    injectFooter();
    injectExitModal();
    bindExitIntent();
    injectFavoritesCta();
    // also fire favorites CTA after favorites JS has mounted
    setTimeout(injectFavoritesCta, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
